module.exports = __webpack_public_path__ + "static/img/PICA.28c7adff.jpg";